import { MACHINE_SERVICE_TYPES } from '../../constants';

// everything except "REPAIR"
export const shouldMachineBeRestocked = machineServiceType => [MACHINE_SERVICE_TYPES.RESTOCK, MACHINE_SERVICE_TYPES.RESTOCK_AND_REPAIR].includes(machineServiceType);
